module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "badges"
  }, [_c('h2', {
    staticClass: "badges__title"
  }, [_vm._v("Bekroningen")]), _vm._m(0), _c('div', {
    staticClass: "badges__list"
  }, _vm._l((_vm.badges), function(badge) {
    return _c('div', {
      key: badge.type,
      staticClass: "badges__item badge",
      class: [("badge--" + (badge.type)), {
        'badge--active': badge.type === _vm.selectedBadge && !_vm.isLoading,
        'badge--disabled': _vm.disabled
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectBadge(badge)
        }
      }
    }, [_c('div', {
      staticClass: "badge__icon"
    }), _c('p', {
      staticClass: "badge__type tag"
    }, [_vm._v(_vm._s(badge.name))])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "tag badges__explanation"
  }, [_c('em', [_vm._v("Deel een bekroning uit als de leerling boven zichzelf uitstijgt (op zijn niveau) in een vaardigheid.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d98cde","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/Badges.vue
// module id = r4bP
// module chunks = 1